import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    title: '',
    description: '',
    price: null,
    currency: 'USD',
    maxDurationSeconds: 120,
    isEnabled: true,
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  itemDesign: {},
  containerDesign: {},
};

export const audioInboxSlice = createSlice({
  name: 'audioInbox',
  initialState,
  reducers: {
    audioInboxStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign ?? {};

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        title: blockContent?.title ?? '',
        description: blockContent?.description ?? '',
        price: blockContent?.price ?? null,
        currency: blockContent?.currency ?? 'USD',
        maxDurationSeconds: blockContent?.maxDurationSeconds ?? 120,
        isEnabled: blockContent?.isEnabled ?? true,
        heading: {
          title: blockContent?.heading?.title ?? '',
          description: blockContent?.heading?.description ?? '',
          textAlign: blockContent?.heading?.textAlign ?? 'left',
          image: blockContent?.heading?.image ?? '',
          divider: blockContent?.heading?.divider ?? '',
          position: blockContent?.heading?.position ?? '',
        },
      };
    },
    audioInboxClear: () => initialState,

    audioInboxUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    audioInboxUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    audioInboxUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
  },
});

export const {
  audioInboxStore,
  audioInboxClear,
  audioInboxUpdateIsLoading,
  audioInboxUpdateIsActive,
  audioInboxUpdateBlockContent,
} = audioInboxSlice.actions;

export const selectAudioInboxIsLoading = (state) => state.audioInbox.isLoading;
export const selectAudioInboxId = (state) => state.audioInbox.id;
export const selectAudioInboxUID = (state) => state.audioInbox.uid;
export const selectAudioInboxSID = (state) => state.audioInbox.sid;
export const selectAudioInboxBlockContent = (state) => state.audioInbox.blockContent;
export const selectAudioInboxItemDesign = (state) => state.audioInbox.itemDesign;
export const selectAudioInboxContainerDesign = (state) => state.audioInbox.containerDesign;

export default audioInboxSlice.reducer;
